import React from "react";

const DropdownIcon = ({ open }) => {
  if (window.innerWidth > 1800)
    return open ? (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
        viewBox="0 0 30 30"
      >
        <g fill="#455ee5">
          <path
            d="M 14.99996948242188 28.99993896484375 C 11.2604398727417 28.99993896484375 7.744739532470703 27.5436897277832 5.100499629974365 24.89943885803223 C 2.456249475479126 22.25519943237305 0.999999463558197 18.73950004577637 0.999999463558197 14.99996948242188 C 0.999999463558197 11.2604398727417 2.456249475479126 7.744739532470703 5.100499629974365 5.100499629974365 C 7.744739532470703 2.456249475479126 11.2604398727417 0.999999463558197 14.99996948242188 0.999999463558197 C 18.73950004577637 0.999999463558197 22.25519943237305 2.456249475479126 24.89943885803223 5.100499629974365 C 27.5436897277832 7.744739532470703 28.99993896484375 11.2604398727417 28.99993896484375 14.99996948242188 C 28.99993896484375 18.73950004577637 27.5436897277832 22.25519943237305 24.89943885803223 24.89943885803223 C 22.25519943237305 27.5436897277832 18.73950004577637 28.99993896484375 14.99996948242188 28.99993896484375 Z"
            transform="rotate(180 15 15)"
          />
          <path
            d="M 14.99996948242188 2 C 11.52754974365234 2 8.262979507446289 3.352230072021484 5.807600021362305 5.807600021362305 C 3.352230072021484 8.262979507446289 2 11.52754974365234 2 14.99996948242188 C 2 18.47238922119141 3.352230072021484 21.73695945739746 5.807600021362305 24.19233894348145 C 8.262979507446289 26.64770889282227 11.52754974365234 27.99993896484375 14.99996948242188 27.99993896484375 C 18.47238922119141 27.99993896484375 21.73695945739746 26.64770889282227 24.19233894348145 24.19233894348145 C 26.64770889282227 21.73695945739746 27.99993896484375 18.47238922119141 27.99993896484375 14.99996948242188 C 27.99993896484375 11.52754974365234 26.64770889282227 8.262979507446289 24.19233894348145 5.807600021362305 C 21.73695945739746 3.352230072021484 18.47238922119141 2 14.99996948242188 2 M 14.99996948242188 0 C 23.28421974182129 0 29.99993896484375 6.715719223022461 29.99993896484375 14.99996948242188 C 29.99993896484375 23.28421974182129 23.28421974182129 29.99993896484375 14.99996948242188 29.99993896484375 C 6.715719223022461 29.99993896484375 0 23.28421974182129 0 14.99996948242188 C 0 6.715719223022461 6.715719223022461 0 14.99996948242188 0 Z"
            transform="rotate(180 15 15)"
          />
        </g>
        <path
          d="M0,0,8.083,8.083,0,16.167"
          transform="rotate(-90 12.98 6.063)"
          fill="#455ee5"
          stroke="#fff"
          strokeMiterlimit="10"
          strokeWidth="2"
        />
      </svg>
    ) : (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
        viewBox="0 0 30 30"
      >
        <g
          id="Group_26112"
          data-name="Group 26112"
          transform="translate(-1825.059 -1011.059)"
        >
          <g
            id="Group_26110"
            data-name="Group 26110"
            transform="translate(55.059 184.059)"
          >
            <g id="Path_42912" data-name="Path 42912" fill="none">
              <path
                d="M15,0A15,15,0,1,1,0,15,15,15,0,0,1,15,0Z"
                transform="translate(1770 827)"
              />
              <path
                d="M 14.99996948242188 2 C 11.52754974365234 2 8.262979507446289 3.352230072021484 5.807600021362305 5.807600021362305 C 3.352230072021484 8.262979507446289 2 11.52754974365234 2 14.99996948242188 C 2 18.47238922119141 3.352230072021484 21.73695945739746 5.807600021362305 24.19233894348145 C 8.262979507446289 26.64770889282227 11.52754974365234 27.99993896484375 14.99996948242188 27.99993896484375 C 18.47238922119141 27.99993896484375 21.73695945739746 26.64770889282227 24.19233894348145 24.19233894348145 C 26.64770889282227 21.73695945739746 27.99993896484375 18.47238922119141 27.99993896484375 14.99996948242188 C 27.99993896484375 11.52754974365234 26.64770889282227 8.262979507446289 24.19233894348145 5.807600021362305 C 21.73695945739746 3.352230072021484 18.47238922119141 2 14.99996948242188 2 M 14.99996948242188 0 C 23.28421974182129 0 29.99993896484375 6.715719223022461 29.99993896484375 14.99996948242188 C 29.99993896484375 23.28421974182129 23.28421974182129 29.99993896484375 14.99996948242188 29.99993896484375 C 6.715719223022461 29.99993896484375 0 23.28421974182129 0 14.99996948242188 C 0 6.715719223022461 6.715719223022461 0 14.99996948242188 0 Z"
                fill="#455ee5"
                transform="translate(1770 827)"
              />
            </g>
          </g>
          <path
            id="Path_42917"
            data-name="Path 42917"
            d="M0,0,8.083,8.083,0,16.167"
            transform="rotate(90 413.062 1435.08)"
            fill="none"
            stroke="#455ee5"
            strokeMiterlimit="10"
            strokeWidth="2"
          />
        </g>
      </svg>
    );
  else
    return open ? (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
      >
        <circle cx="10" cy="10" r="10" fill="#455ee5" />
        <path
          d="M0,0,5.286,5.286,0,10.571"
          transform="translate(4.75 12.536) rotate(-90)"
          fill="#455ee5"
          stroke="#fff"
          strokeMiterlimit="10"
          strokeWidth="2"
        />
      </svg>
    ) : (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
      >
        <g transform="translate(-1144 -703)">
          <g transform="translate(1144 703)" fill="none">
            <path
              d="M10,0A10,10,0,0,1,20,10a10.178,10.178,0,0,1-2.07,6.093A9.84,9.84,0,0,1,10,20,10,10,0,0,1,10,0Z"
              stroke="none"
            />
            <path
              d="M 10 2 C 5.588789939880371 2 2 5.588789939880371 2 10 C 2 14.41121006011963 5.588789939880371 18 10 18 C 11.28308963775635 18 12.56219005584717 17.69392967224121 13.69903945922852 17.11489105224609 C 14.76574993133545 16.57155990600586 15.66732978820801 15.81442070007324 16.30632019042969 14.9253101348877 L 16.30851936340332 14.92224979400635 L 16.31072998046875 14.919189453125 C 17.44743919372559 13.35006999969482 18 11.74098968505859 18 10 C 18 5.588789939880371 14.41121006011963 2 10 2 M 10 0 C 15.52285003662109 0 20 4.477149963378906 20 10 C 20 12.18152046203613 19.30146026611328 14.19988059997559 17.93040084838867 16.09251022338867 C 16.2999095916748 18.36124038696289 13.34132957458496 20 10 20 C 4.477149963378906 20 0 15.52285003662109 0 10 C 0 4.477149963378906 4.477149963378906 0 10 0 Z"
              stroke="none"
              fill="#455ee5"
            />
          </g>
          <path
            d="M0,0,5.286,5.286,0,10.571"
            transform="translate(1159.321 710.25) rotate(90)"
            fill="none"
            stroke="#455ee5"
            strokeMiterlimit="10"
            strokeWidth="2"
          />
        </g>
      </svg>
    );
};

export default DropdownIcon;
